import { render } from "./ListNODRIZERSView.vue?vue&type=template&id=567117b8&scoped=true"
import script from "./ListNODRIZERSView.vue?vue&type=script&lang=js"
export * from "./ListNODRIZERSView.vue?vue&type=script&lang=js"

import "./ListNODRIZERSView.vue?vue&type=style&index=0&id=567117b8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tribuk-ui/tribuk-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567117b8"]])

export default __exports__